import { render, staticRenderFns } from "./bo-product-matrix.vue?vue&type=template&id=adbbbe26"
import script from "./bo-product-matrix.vue?vue&type=script&lang=js"
export * from "./bo-product-matrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports